import React, { useState, useEffect } from "react";
import { Box, Tooltip } from "@mui/material";
import { CommonHeading } from "./CommonHeading";
import { CommonButton } from "./CommonButton";
import { useSelector } from "react-redux";
import {
  getFeatureSetOption,
  getFeaturesList,
  isUserAdmin,
  isUserReadOnly,
  isUserSupport,
  featureKey,
} from "../../../constant";
import { useHookstate } from "@hookstate/core";
import {
  MAP_GLOBAL_STATES,
  SIDENAV_GLOBAL_STATE,
  ADS_GLOBAL_STATE,
  CPO_GLOBAL_STATES,
  SiteSetupAction,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import {
  CarsSection,
  HistorySection,
  ActionZonesSection,
  CarPathSection,
  SiteSetup,
} from "../subSectionNav";
import CarImage from "assets/svgIcons/MapSubSIdeNav/CarIcon";
import HistoryImage from "assets/svgIcons/MapSubSIdeNav/HistoryIcon";
import ActionZoneImage from "assets/svgIcons/MapSubSIdeNav/ActionZoneIcon";
import CarPathImage from "assets/svgIcons/MapSubSIdeNav/CPOIcon";
import SiteSetupIcon from "assets/svgIcons/SiteSetupIcon";
import AlertModal from "commonComponents/Popup/alertModal";
import {
  SideNavTabsWrapper,
  SubSideNavTabs,
} from "commonComponents/SideNav/subSideNav/subSideNavStyled";
import { SiteSetupWindow } from "commonComponents/SideNav/sideNavSubWindows/SiteSetupWindow";
import { useFilteredMapCarsHook } from "customHooks/useFilteredData";
import {
  setUpdatedCarsDataState,
  specificCarHistoryDataAction,
} from "redux/reduxToolkitServices/_commonReducers/commonReducers";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

export const MapSideNav = () => {
  const {
    mapSideNavTabState,
    fleetCarsGlobalState,
    specialCarsGlobalState,
    memberCarsGlobalState,
    marshalCarsGlobalState,
    beverageCarsGlobalState,
    notInUseCarsGlobalState,
    carsNotCommunicatingGlobalState,
    outsidePerimeterGlobalState,
    messageActionZone,
    controlsActionZone,
    cartPathActionZone,
    geofenceActionZone,
    actionZoneModified,
    refreshActionZones,
    currentClickedTab,
  } = useHookstate(MAP_GLOBAL_STATES);

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const { openSaveChangesModal, carPathUnSavedChanges, nextSubTabIndex } =
    useHookstate(CPO_GLOBAL_STATES);

  const {
    showAreas,
    showCenterOfGreens,
    showTeeMarkers,
    showPointsOfInterest,
    addSiteSetup,
    editSiteSetup,
    areaModified,
    refreshSiteSetupAreas,
  } = useHookstate(SiteSetupAction);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showArea, setShowArea] = useState(false);
  const [cpoDiscardChanges, setCpoDiscardChanges] = useState(false);
  const [isCommercial, setIsCommercial] = useState(false);

  const { getUserRole, siteSettingsData } =
    useSelector((state) => state.commonReducers) || [];

  const { getSelectedCarsMapState } = useFilteredMapCarsHook({
    marshalCars: marshalCarsGlobalState.get(),
    specialCars: specialCarsGlobalState.get(),
    memberCars:  memberCarsGlobalState.get(),
    beverageCars: beverageCarsGlobalState.get(),
    fleetCars: fleetCarsGlobalState.get(),
    notInUseCars: notInUseCarsGlobalState.get(),
    notCommunicatingCars: carsNotCommunicatingGlobalState.get(),
    outsidePerimeter: outsidePerimeterGlobalState.get(),
  });

  const { subNavDataState, sideNavMapState, sideDrawerActiveTabState } =
    useHookstate(SIDENAV_GLOBAL_STATE);
  const { redirectState, alertMsg, nextTabIndex } =
    useHookstate(ADS_GLOBAL_STATE);

  useEffect(() => {
    setIsCommercial(
      siteSettingsData?.Features?.indexOf(featureKey.resortEdition) >= 0
    );
  }, [siteId.get(), siteSettingsData]);

  useEffect(() => {
    var tabList = ["MAP", "Cars", "History", "Action_Zones", "CPO", "Site Setup"];
    
    if (tabList.includes(subNavDataState.get())) {
      if (getSelectedCarsMapState.get() && getSelectedCarsMapState.get().length !== 0) {
        let carsData = JSON.parse(JSON.stringify(getSelectedCarsMapState.get()));
        dispatch(setUpdatedCarsDataState(carsData));
      }
    }
  }, [
    marshalCarsGlobalState.get(),
    specialCarsGlobalState.get(),
    memberCarsGlobalState.get(),
    beverageCarsGlobalState.get(),
    fleetCarsGlobalState.get(),
    notInUseCarsGlobalState.get(),
    carsNotCommunicatingGlobalState.get(),
    subNavDataState.get(),
    mapSideNavTabState.get(),
  ]);

  const cpoDiscardChangesOnYes = () => {
    setCpoDiscardChanges(false);
    localStorage.setItem("activeMapSideNavTab", currentClickedTab.get());
    localStorage.setItem("mapSideNavTabState", currentClickedTab.get());
    mapSideNavTabState.set(currentClickedTab.get());

    refreshSiteSetupAreas.set(true);
  };

  useEffect(() => {
    editSiteSetup.set(false);
  }, [mapSideNavTabState.get()]);

  useEffect(() => {
    let getSubnavName = localStorage.getItem("activeMapSideNavTab");
    mapSideNavTabState.set(getSubnavName);
    if (mapSideNavTabState.get() === "Site Setup") setShowArea(true);
    let actionZoneButton = JSON.parse(localStorage.getItem("actionZoneButton"));
    if (actionZoneButton) showEnabledActionZones();
  }, []);

  const sideSubnavData = () => {
    switch (mapSideNavTabState.get()) {
      case "Cars":
        return <CarsSection />;
      case "History":
        return <HistorySection />;
      case "Action Zones":
        return <ActionZonesSection />;
      case "CPO":
        return <CarPathSection />;
      case "Site Setup":
        return <SiteSetup />;
      default:
        return;
    }
  }

  const hideAllActionZones = () => {
    messageActionZone.set(false);
    controlsActionZone.set(false);
    cartPathActionZone.set(false);
    geofenceActionZone.set(false);
    localStorage.setItem("actionZoneButton", "false");
  }

  const showEnabledActionZones = () => {
    let messageZone = localStorage.getItem("messageActionZone");
    if (messageZone) messageActionZone.set(JSON.parse(messageZone));
    let controlZone = localStorage.getItem("controlsActionZone");
    if (controlZone) controlsActionZone.set(JSON.parse(controlZone));
    let cartPathZone = localStorage.getItem("cartPathActionZone");
    if (cartPathZone) cartPathActionZone.set(JSON.parse(cartPathZone));
    let geofenceZone = localStorage.getItem("geofenceActionZone");
    if (geofenceZone) geofenceActionZone.set(JSON.parse(geofenceZone));

    localStorage.setItem("actionZoneButton", "true");
  }

  const handleCallback = (childData) => {
    setShowArea(childData);
  }

  const handleCarsTab = () => {
    currentClickedTab.set("Cars");

    if (carPathUnSavedChanges.get()) {
      openSaveChangesModal.set(true);

      nextSubTabIndex.set("Cars");
    } else if (areaModified.get()) {
      setCpoDiscardChanges(true);
    } else if (actionZoneModified.get()) {
      refreshActionZones.set(true);
    } else if (redirectState.get()) {
      alertMsg.set(true);
      nextTabIndex.set("Cars");
    } else {
      localStorage.setItem("activeMapSideNavTab", "Cars");
      localStorage.setItem("mapSideNavTabState", "Cars");
      mapSideNavTabState.get() === "Cars"
        ? mapSideNavTabState.set("")
        : mapSideNavTabState.set("Cars");
    }
  }

  const handleHistoryTab = () => {
    currentClickedTab.set("History");

    if (carPathUnSavedChanges.get()) {
      openSaveChangesModal.set(true);
      nextSubTabIndex.set("History");
    } else if (areaModified.get()) {
      setCpoDiscardChanges(true);
    } else if (actionZoneModified.get()) {
      refreshActionZones.set(true);
    } else if (redirectState.get()) {
      alertMsg.set(true);
      nextTabIndex.set("History");
    } else {
      localStorage.setItem("activeMapSideNavTab", "History");
      localStorage.setItem("mapSideNavTabState", "History");
      if (mapSideNavTabState.get() === "History") {
        mapSideNavTabState.set("");
        // clearing car history in case of toggle of history button
        dispatch(specificCarHistoryDataAction([]));
        localStorage.removeItem("historySelectedCar");
      } else {
        mapSideNavTabState.set("History");
      }
    }
  }

  const handleActionZoneTab = () => {
    currentClickedTab.set("Action Zones");

    if (carPathUnSavedChanges.get()) {
      openSaveChangesModal.set(true);
      nextSubTabIndex.set("Action Zones");
    } else if (areaModified.get()) {
      setCpoDiscardChanges(true);
    } else if (redirectState.get()) {
      alertMsg.set(true);
      nextTabIndex.set("Action_Zones");
    } else {
      localStorage.setItem("activeMapSideNavTab", "Action Zones");
      localStorage.setItem("mapSideNavTabState", "Action Zones");
      mapSideNavTabState.get() === "Action Zones"
        ? mapSideNavTabState.set("")
        : mapSideNavTabState.set("Action Zones");
      if (mapSideNavTabState.get() === "") hideAllActionZones();
      if (mapSideNavTabState.get() === "Action Zones") showEnabledActionZones();
    }
  }

  const handleCpoTab = () => {
    currentClickedTab.set("CPO");

    if (carPathUnSavedChanges.get()) {
      openSaveChangesModal.set(true);
      nextSubTabIndex.set("CPO");
    } else if (areaModified.get()) {
      setCpoDiscardChanges(true);
    } else if (actionZoneModified.get()) {
      refreshActionZones.set(true);
    } else if (redirectState.get()) {
      alertMsg.set(true);
      nextTabIndex.set("CPO");
    } else {
      localStorage.setItem("activeMapSideNavTab", "CPO");
      localStorage.setItem("mapSideNavTabState", "CPO");
      if (mapSideNavTabState.get() === "CPO") {
        mapSideNavTabState.set("");
        cartPathActionZone.set(false);
      } else {
        mapSideNavTabState.set("CPO");
        cartPathActionZone.set(true);
      }
      localStorage.setItem("actionZoneButton", "false");
    }
  }

  const handleSiteSetupTab = () => {
    currentClickedTab.set("Site Setup");

    if (carPathUnSavedChanges.get()) {
      openSaveChangesModal.set(true);
      nextSubTabIndex.set("Site Setup");
    } else if (areaModified.get() || actionZoneModified.get()) {
      setCpoDiscardChanges(true);
    } else if (actionZoneModified.get()) {
      refreshActionZones.set(true);
    } else if (redirectState.get()) {
      alertMsg.set(true);
      nextTabIndex.set("Site Setup");
    } else {
      localStorage.setItem("activeMapSideNavTab", "Site Setup");
      localStorage.setItem("mapSideNavTabState", "Site Setup");
      if (mapSideNavTabState.get() === "Site Setup") {
        mapSideNavTabState.set("");
        showAreas.set(false);
        showCenterOfGreens.set(false);
        showTeeMarkers.set(false);
        showPointsOfInterest.set(false);
        addSiteSetup.set(false);
        editSiteSetup.set(false);
      } else mapSideNavTabState.set("Site Setup");
      setShowArea(true);
      localStorage.setItem("actionZoneButton", "false");
    }
  }

  const enabledForTracking = () => {
    return (
      !getFeatureSetOption(
        siteSettingsData && siteSettingsData?.Features,
        getFeaturesList().real_time_tracking
      ) ||
      isUserAdmin(getUserRole && getUserRole.Role) ||
      isUserSupport(getUserRole && getUserRole.Role)
    );
  }

  const enabledForCarControl = () => {
    return (
      (!getFeatureSetOption(
          siteSettingsData && siteSettingsData?.Features,
          getFeaturesList().car_control
        ))
    );
  }

  return (
    <div>
      <CommonHeading labelText={t("Map")} iconSrc="MapIconImage" />
      <SideNavTabsWrapper>
        <SubSideNavTabs>
          <Tooltip title={t("Cars")} arrow>
            <span>
              <CommonButton
                labelText={"Cars"}
                displayText={"Cars"}
                changeSideNavData={() => handleCarsTab()}
                buttonNumber={1}
                disabled={!enabledForTracking()}
              >
                <CarImage
                  color={
                    mapSideNavTabState.get() === "Cars" &&
                    sideDrawerActiveTabState.get() === 1 &&
                    sideNavMapState.get()
                      ? "var(--theme-text)"
                      : "var(--text-secondary)"
                  }
                />
              </CommonButton>
            </span>
          </Tooltip>

          <Tooltip title={t("History")} arrow>
            <span>
              <CommonButton
                labelText={"History"}
                displayText={"History"}
                changeSideNavData={() => handleHistoryTab()}
                buttonNumber={2}
              >
                <HistoryImage
                  color={
                    mapSideNavTabState.get() == "History" &&
                    sideNavMapState.get()
                      ? "var(--theme-text)"
                      : "var(--text-secondary)"
                  }
                />
              </CommonButton>
            </span>
          </Tooltip>

          <Tooltip title={t("Action_Zones")} arrow>
            <span>
              <CommonButton
                labelText={"Action Zones"}
                displayText={"Action_Zones"}
                changeSideNavData={() => handleActionZoneTab()}
                buttonNumber={3}
              >
                <ActionZoneImage
                  color={
                    mapSideNavTabState.get() == "Action Zones" &&
                    sideNavMapState.get()
                      ? "var(--theme-text)"
                      : "var(--text-secondary)"
                  }
                />
              </CommonButton>
            </span>
          </Tooltip>

          <Tooltip
            title={isCommercial ? t("Action_Zone_groups") : t("Cart-path_Only")}
            arrow
          >
            <span>
              <CommonButton
                labelText={"CPO"}
                displayText={isCommercial ? t("AZG") : "CPO"}
                changeSideNavData={() => handleCpoTab()}
                buttonNumber={4}
                disabled={!(enabledForCarControl() || enabledForTracking())}
              >
                {isCommercial ? (
                  <SiteSetupIcon
                    color={
                      mapSideNavTabState.get() === "CPO" &&
                      sideNavMapState.get()
                        ? "var(--theme-text)"
                        : "var(--text-secondary)"
                    }
                  />
                ) : (
                  <CarPathImage
                    color={
                      mapSideNavTabState.get() === "CPO" &&
                      sideNavMapState.get()
                        ? "var(--theme-text)"
                        : "var(--text-secondary)"
                    }
                  />
                )}
              </CommonButton>
            </span>
          </Tooltip>
          {isUserAdmin(getUserRole && getUserRole?.Role) ? (
            <>
              <Tooltip title={t("Site_Setup")} arrow>
                <span className="site-setup">
                  <CommonButton
                    labelText={"Site Setup"}
                    displayText={"Site_Setup"}
                    changeSideNavData={() => handleSiteSetupTab()}
                    buttonNumber={5}
                  >
                    <SiteSetupIcon
                      color={
                        mapSideNavTabState.get() == "Site Setup"
                          ? "var(--theme-text)"
                          : "var(--text-secondary)"
                      }
                    />
                  </CommonButton>
                </span>
              </Tooltip>
            </>
          ) : (
            <></>
          )}
        </SubSideNavTabs>
        <Box>
          {((mapSideNavTabState.get() !== "Cars" &&
            mapSideNavTabState.get() !== "CPO") ||
            (mapSideNavTabState.get() === "Cars" && enabledForTracking()) ||
            (mapSideNavTabState.get() === "CPO" && (enabledForCarControl() || enabledForTracking()))) &&
            sideSubnavData()}
          {showArea && mapSideNavTabState.get() === "Site Setup" ? (
            <SiteSetupWindow parentCallback={handleCallback} />
          ) : null}
        </Box>
      </SideNavTabsWrapper>
      <AlertModal
        handleOnSubmit={cpoDiscardChangesOnYes}
        title={t("Confirm")}
        content={t("Discard_changes") + " ?"}
        isOpen={cpoDiscardChanges}
        setOpenAlert={setCpoDiscardChanges}
      />
    </div>
  );
};
